module.exports = __webpack_public_path__ + "static/media/location.f76d894c.jpg";